export const API_URL = {
    'populateSerialTransfer' : 'api/inventory/vas/transfer/serial/populate',
    'EXPLODE_BY_KEY_KITTING': 'api/inventory/vas/kitting/explodeByPackKey',
    'UCC_POPULATE': 'api/inventory/adjustment/ucc/populate',
    'PACK_MNGT_EDIT' : 'api/core/packmgmnttd',
    'SO_CUSTOMS_MSG': 'api/wave/customs/customsserviceorder',
    'WAVE_CTRL': (waveKey) => `api/shipref/customs/${waveKey}`,
    'RIGHTS': 'api/app/rights',
    'POPULATE_ALL': 'api/inventory/adjustment/populate/all',
    'UCC_POPULATE_ALL': 'api/inventory/adjustment/ucc/populate/all',
    'ASN_CUSTOMS': 'api/asn/submit/import/declaration'
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/api-urls.ts